var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1765 13.044C22.1765 7.5964 17.8783 3 12.5882 3C7.29817 3 3 7.6645 3 13.1461C3 15.2911 3.66126 17.4021 4.7854 19.1044L8.68682 24.6882L12.0923 29.6932C12.3568 30.0677 12.8858 30.0677 13.1172 29.6932L16.5227 24.7222L20.4241 19.1044C21.5152 17.4021 22.1765 15.189 22.1765 13.044Z",
    fill: "#396FC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66385 19.845L3.67357 19.8597L3.68368 19.8742L7.58032 25.4511L10.9811 30.4492L10.9877 30.4589L10.9945 30.4685C11.75 31.5383 13.4411 31.6754 14.2398 30.4327L17.6266 25.4889L17.6315 25.4818L21.528 19.8711L21.5422 19.8506L21.5557 19.8297C22.7866 17.9091 23.5205 15.4439 23.5205 13.044C23.5205 6.92197 18.6866 1.656 12.5882 1.656C6.47564 1.656 1.656 7.00512 1.656 13.1461C1.656 15.5593 2.3973 17.927 3.66385 19.845Z",
    stroke: "white",
    strokeOpacity: 0.97427,
    strokeWidth: 2.688
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7354 15.8126C14.6684 15.8126 16.2354 14.2456 16.2354 12.3126C16.2354 10.3796 14.6684 8.81262 12.7354 8.81262C10.8024 8.81262 9.23541 10.3796 9.23541 12.3126C9.23541 14.2456 10.8024 15.8126 12.7354 15.8126Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMarker);
export default __webpack_public_path__ + "static/media/blue_marker.6908f84984963ddbfc9f550ed736572b.svg";
export { ForwardRef as ReactComponent };